import type { Placement } from "@floating-ui/react";
import { FloatingTooltip } from "../Tooltip/FloatingTooltip";

const InfoIconWithTooltip = ({
  message,
  className = "",
  placement = "top",
  nested = false,
}: {
  message: string;
  className?: string;
  placement?: Placement;
  nested?: boolean;
}) => {
  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.5"
      className="h-4 w-4"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v5.5m0-8h.01" />
    </svg>
  );
  const iconClassName = `inline-flex shrink-0 cursor-help text-gray-400 ${className}`;

  return (
    <FloatingTooltip content={message} placement={placement} ariaHidden>
      {nested ? (
        <span role="img" aria-label={message} tabIndex={0} className={iconClassName}>
          {icon}
        </span>
      ) : (
        <button type="button" aria-label={message} className={iconClassName}>
          {icon}
        </button>
      )}
    </FloatingTooltip>
  );
};

export default InfoIconWithTooltip;
